module.exports = __webpack_public_path__ + "illus-dojo-mark.NUT320Wn.svg";